import { render, staticRenderFns } from "./LinhaTabela.vue?vue&type=template&id=eb983836"
import script from "./LinhaTabela.vue?vue&type=script&lang=js"
export * from "./LinhaTabela.vue?vue&type=script&lang=js"
import style0 from "./LinhaTabela.vue?vue&type=style&index=0&id=eb983836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports